module.exports = __webpack_public_path__ + "img/API.71b7a3fb.png";